export function homepageBlog() {
     // slick on mobile
     var $blogRoll = jQuery('.feature-blog .grid-container');
     if (jQuery(window).width() > 767) {
         if ($blogRoll.hasClass('slick-initialized')) {
             $blogRoll.slick('unslick');
         }
     } else {
         if (!$blogRoll.hasClass('slick-initialized')) {
             $blogRoll.slick({
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 dots: true,
                 rows: 0,
                 infinite: true,
                 prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
                 nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
             });
         }
     }
}